import { object, string } from 'yup';
import { validateCPF } from '../../../utils/validators';
import { VehicleType } from './Step3';
import moment from 'moment';
import { Holidays } from '@/utils/feriados';

const requiredSchema = string().required('Preenchimento obrigatório');

const phoneSchema = string().test('valid-phone', 'Telefone inválido', (value) => {
  if (!value) return true;

  const cleanValue = value.replace(/[^0-9]/gi, '');
  return cleanValue.length === 10 || cleanValue.length === 11;
});

const cpfSchema = string().test('is-valid-cpf', 'CPF inválido', (value) => {
  return validateCPF(value);
});

const validateInstallDateSchema = string().test(
  'is-valid-install-date',
  'Data indisponível',
  (value) => {
    const date = moment(value).format('DD/MM/yyyy');
    const invalid = Holidays.includes(date);

    return !invalid;
  },
);

export const Step1Validation = {
  responsibleName: requiredSchema.trim().min(2, 'Nome inválido').max(100, 'Nome inválido'),
  responsiblePhone: requiredSchema.concat(phoneSchema),
  responsiblePhone2: phoneSchema,
  responsibleEmail: requiredSchema.email('Email inválido'),
  clientCPF: requiredSchema.concat(cpfSchema),
  proposalNumber: requiredSchema
    .max(9, 'Número de proposta inválida')
    .min(6, 'Número de proposta inválida'),
};

export const Step2Validation = {
  storeName: requiredSchema.trim().min(2, 'Nome inválido').max(100, 'Nome inválido'),
  storeZipcode: requiredSchema,
  storeAddress: requiredSchema.trim().min(2, 'Endereço inválido').max(100, 'Endereço inválido'),
  storeNumber: requiredSchema.trim().min(1, 'Número inválido').max(100, 'Número inválido'),
  storeDistrict: requiredSchema.trim().min(2, 'Bairro inválido').max(100, 'Bairro inválido'),
  storeCity: requiredSchema,
  storeState: requiredSchema,
};

export const Step3Validation = {
  vehicleType: string().required('Selecione o tipo o veículo'),
  vehicleModel: requiredSchema.trim().min(2, 'Modelo inválido').max(100, 'Modelo inválido'),
  vehicleChassi: requiredSchema.trim().min(17, 'Chassi inválido').max(17, 'Chassi inválido'),
  vehicleChassi2: requiredSchema,
  vehiclePlate: requiredSchema.length(7, 'Placa inválida'),
  installDate: validateInstallDateSchema.required('Selecione uma data'),
  installTime: requiredSchema,
};

export function getValidator(currentStep, values) {
  let obj = {};

  if (currentStep >= 1) {
    obj = { ...obj, ...Step1Validation };
  }

  if (currentStep >= 2) {
    obj = { ...obj, ...Step2Validation };
  }

  if (currentStep >= 3) {
    obj = { ...obj, ...Step3Validation };
  }

  // -------- custom rules --------

  if (values && values.vehicleType === VehicleType.NOVO) {
    delete obj.vehiclePlate;
  }

  if (values && values.vehicleChassi && obj.vehicleChassi2) {
    obj.vehicleChassi2 = obj.vehicleChassi2.concat(
      string().test('matches-chassi', 'Os números do chassi devem ser iguais', (value) => {
        return value === values.vehicleChassi;
      }),
    );
  }

  return object().shape(obj);
}
